export default __webpack_public_path__ + "static/media/sh2_3.4032201e.jpg";